'use client'

import {useState, useMemo} from 'react'
import {SlideshowNative} from '@local/ui/components'
import {cx} from '@local/utils/cx'

import {VariantCard, VariantCardProps} from './VariantCard'
import {VariantPanel} from './VariantPanel'

export interface VariantsSlideshowProps {
	className?: string
	accomodations: Array<VariantCardProps>
}

export const VariantsSlideshow = ({className, accomodations}: VariantsSlideshowProps) => {
	const [activeIndex, setActiveIndex] = useState<number>(-1)
	const panelVariants = useMemo(() => accomodations?.map(({variants, ...rest}) => ({
		title: variants[0]?.option1 || variants[1]?.option1 || variants[0]?.title,
		price: variants[0]?.price || variants[1]?.price,
		gids: variants.filter(variant => variant && variant.gid).map(variant => variant.gid),
		dates: variants.filter(variant => variant && variant.option2).map(variant => variant.option2),
		peoplePerRoom: Math.max(...variants.map(variant => variant?.peoplePerRoom || 1)),
		...rest,
	})), [accomodations])

	const handleIndex = (index) => {
		setActiveIndex(index)
	}

	if (!accomodations.length) return <></>

	return (
		<>
			<SlideshowNative
				containerClassName={cx('relative overflow-x-clip', className)}
				className='margin-px-1 gutter-gap-1 scroll-pl-[var(--margin)]'
				withPrevNextNavigation={accomodations.length > 3}
				prevNextNavigationClassName={cx(
					'lg-max:hidden',
					'absolute -top-128 margin-right-1 flex items-center justify-center z-1',
				)}
				prevNextButtonVariant='icon'
				prevNextButtonClassName='bg-transparent disabled:border-grey-1 rounded-md p-0 w-38 h-38'
				disableObserverOnMobile
				threshold={0.8}>
				{accomodations.map((item, index) => (
					<VariantCard {...item} index={index} key={index} onClick={() => handleIndex(index)} />
				))}
			</SlideshowNative>
			{!!panelVariants.length && panelVariants.map((variant, index) => (
				<VariantPanel
					{...variant}
					index={index}
					key={`panel-${index}`}
					isOpen={activeIndex === index}
					onClickClose={() => setActiveIndex(-1)} />
			))}
		</>
	)
}
